"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5892],{

/***/ 15892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72770);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99280);
/* harmony import */ var _lib_services_pageService__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63392);
/* harmony import */ var _lib_utilities_page__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54767);









var settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: false,
    variableWidth: false,
    adaptiveHeight: false,
    fade: true
};
var Testimonials = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), testimonials = ref[0], setTestimonials = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_lib_services_pageService__WEBPACK_IMPORTED_MODULE_5__/* .getCustomerTestimonialsService */ .AJ)().then(function(res) {
            setTestimonials(res);
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "section-customer-testimonials",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "grid__container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid__row",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, settings), {
                    children: testimonials.map(function(testimonial) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "testimonial",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "testimonial__image",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_4__/* .constants.imageHost.assets */ ._G.imageHost.assets, "/testimonials/").concat(testimonial.image),
                                        height: "240",
                                        width: "240",
                                        alt: "".concat(testimonial.name, " and their ").concat(testimonial.manufacturer)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "testimonial__description",
                                    children: testimonial.description
                                }),
                                testimonial.manufacturer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "testimonial__name",
                                    children: [
                                        testimonial.name,
                                        " leased",
                                        (0,_lib_utilities_page__WEBPACK_IMPORTED_MODULE_8__/* .isVowel */ .rC)(testimonial.manufacturer.charAt(0)) ? " an " : " a ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: testimonial.manufacturer
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "testimonial__name",
                                    children: testimonial.name
                                })
                            ]
                        }, testimonial.id);
                    })
                }))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Testimonials);


/***/ }),

/***/ 63392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ getCustomerTestimonialsService; },
/* harmony export */   "oF": function() { return /* binding */ getPageContentListService; }
/* harmony export */ });
/* unused harmony exports getAdvancedLandingPageDealService, getPageContentItemService, getFaqArticleContentService, getCareersContentService */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _endpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19931);
/* harmony import */ var _restService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39177);





var getAdvancedLandingPageDealService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(adReference) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.advancedLandingPageDeal */ .l.advancedLandingPageDeal, {
                            adReference: adReference
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getAdvancedLandingPageDealService(adReference) {
        return _ref.apply(this, arguments);
    };
}();
var getPageContentListService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(params) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.pageContentList */ .l.pageContentList, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, params))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getPageContentListService(params) {
        return _ref.apply(this, arguments);
    };
}();
var getPageContentItemService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(params) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.pageContent */ .l.pageContent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, params))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getPageContentItemService(params) {
        return _ref.apply(this, arguments);
    };
}();
var getFaqArticleContentService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.faqArticles */ .l.faqArticles)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getFaqArticleContentService() {
        return _ref.apply(this, arguments);
    };
}();
var getCareersContentService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.careers */ .l.careers)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getCareersContentService() {
        return _ref.apply(this, arguments);
    };
}();
var getCustomerTestimonialsService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.testimonials */ .l.testimonials)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getCustomerTestimonialsService() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 54767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OZ": function() { return /* binding */ getGuideCategoryName; },
/* harmony export */   "VI": function() { return /* binding */ getTrustpilotStarRating; },
/* harmony export */   "of": function() { return /* binding */ getTrustpilotLabel; },
/* harmony export */   "rC": function() { return /* binding */ isVowel; }
/* harmony export */ });
/* unused harmony exports getGuideCategoryType, getReviewHeading */
var getGuideCategoryName = function(urlKey) {
    switch(urlKey){
        case "personal-car-leasing":
            return "Personal Car Leasing";
        case "contracts-and-finance":
            return "Contracts & Finance";
        case "business-car-leasing":
            return "Business Car Leasing";
        case "hybrid-and-electric-leasing":
            return "Hybrid & Electric Leasing";
        case "van-leasing-guide":
            return "Van Leasing";
        case "leasing-with-leaseloco":
            return "Leasing With LeaseLoco";
        default:
            return "LeaseLoco Guide";
    }
};
var getGuideCategoryType = function(urlKey) {
    switch(urlKey){
        case "personal-car-leasing":
            return "GUIDE_PERSONAL";
        case "contracts-and-finance":
            return "GUIDE_CONTRACTS_FINANCE";
        case "business-car-leasing":
            return "GUIDE_BUSINESS";
        case "hybrid-and-electric-leasing":
            return "GUIDE_ELECTRIC";
        case "van-leasing-guide":
            return "GUIDE_VAN";
        case "leasing-with-leaseloco":
            return "GUIDE_LEASELOCO";
        default:
            return "GUIDE_LEASING";
    }
};
var getReviewHeading = function(text) {
    switch(text){
        case "tenSecondReview":
            return "Ten second review";
        case "background":
            return "Background";
        case "designAndBuild":
            return "Design and build";
        case "marketAndModel":
            return "Market and model";
        case "costOfOwnership":
            return "Cost of ownership";
        case "summary":
            return "Summary";
        default:
            return text;
    }
};
var isVowel = function(letter) {
    return letter === "A" || letter === "E" || letter === "I" || letter === "O" || letter === "U";
};
var getTrustpilotStarRating = function(rating) {
    if (rating >= 1 && rating <= 1.2) {
        return 1;
    }
    if (rating >= 1.3 && rating <= 1.7) {
        return 1.5;
    }
    if (rating >= 1.8 && rating <= 2.2) {
        return 2;
    }
    if (rating >= 2.3 && rating <= 2.7) {
        return 2.5;
    }
    if (rating >= 2.8 && rating <= 3.2) {
        return 3;
    }
    if (rating >= 3.3 && rating <= 3.7) {
        return 3.5;
    }
    if (rating >= 3.8 && rating <= 4.2) {
        return 4;
    }
    if (rating >= 4.3 && rating <= 4.7) {
        return 4.5;
    }
    if (rating >= 4.8 && rating <= 5) {
        return 5;
    }
    return rating;
};
var getTrustpilotLabel = function(rating) {
    if (rating >= 1 && rating <= 1.7) {
        return "Bad";
    }
    if (rating >= 1.8 && rating <= 2.7) {
        return "Poor";
    }
    if (rating >= 2.8 && rating <= 3.7) {
        return "Average";
    }
    if (rating >= 3.8 && rating <= 4.2) {
        return "Great";
    }
    if (rating >= 4.3 && rating <= 5) {
        return "Excellent";
    }
    return rating;
};


/***/ })

}]);